export default {
  photo: "object",
}
